<!-- 公共自定义按钮/背景设置 -->
<template>
  <div :style="styleObj">
    <el-form-item :label="`${bgLabelText}：`" :label-width="labelWidth">
      <div class="buttonGroup" v-if="isBgUrl">
        <el-upload
          class="upload"
          action="/jd-hd-web/image/upload"
          :show-file-list="false"
          :before-upload="beforeUploadUI"
          :on-success="handleUploadUI"
        >
          <div class="bg-wrap" v-if="customerPaperwork[bgKey]">
            <img :src="customerPaperwork[bgKey]" class="bg-wrap-img" />
          </div>
          <jd-button
            v-else
            type="blueLine"
            label="自定义上传"
            :disabled="backgroundOpacity"
          ></jd-button>
        </el-upload>
        <jd-button
          type="blueText"
          @click="customerPaperwork[bgKey] = ''"
          class="ml16"
          :disabled="backgroundOpacity"
          >重置</jd-button
        >
        <span class="size-tip">尺寸建议：{{ pw }}*{{ ph }}px</span>
      </div>
      <div class="flexc-cen-x" v-else>
        <el-color-picker
          v-model="customerPaperwork[bgKey]"
          :disabled="backgroundOpacity"
          class="colorPicker"
        >
        </el-color-picker>
        <jd-button
          class="ml16"
          type="blueText"
          :disabled="backgroundOpacity"
          @click="customerPaperwork[bgKey] = resetBgColor"
          >重置</jd-button
        >
      </div>
    </el-form-item>
    <div>
      <slot></slot>
    </div>
    <el-form-item :label="`${colorLabelText}：`" :label-width="labelWidth">
      <div class="flexc-cen-x">
        <el-color-picker
          v-model="customerPaperwork[colorKey]"
          :disabled="backgroundOpacity"
        >
        </el-color-picker>
        <jd-button
          class="ml16"
          type="blueText"
          :disabled="backgroundOpacity"
          @click="customerPaperwork[colorKey] = resetColor"
          >重置</jd-button
        >
      </div>
    </el-form-item>
  </div>
</template>
<script>
const ALLOWED_EXTENSIONS = [".png", ".jpg"];
const DEFAULT_WIDTH = 200;
const DEFAULT_HEIGHT = 200;

export default {
  props: {
    customerData: {
      type: Object,
      default: () => ({}),
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    // 背景键
    bgKey: {
      type: String,
      default: "",
    },
    // 颜色键
    colorKey: {
      type: String,
      default: "",
    },
    // 图片宽度
    pw: {
      type: Number,
      default: DEFAULT_WIDTH,
    },
    // 图片高度
    ph: {
      type: Number,
      default: DEFAULT_HEIGHT,
    },
    // 重置颜色
    resetColor: {
      type: String,
      default: "",
    },
    // 标签文本
    labelText: {
      type: String,
      default: "",
    },
    // 自定义样式对象
    styleObj: {
      type: Object,
      default: () => ({}),
    },
    // 是否限制尺寸
    isLimitSize: {
      type: Boolean,
      default: false,
    },
    // 背景标签文本
    bgLabelText: {
      type: String,
      default: "背景",
    },
    // 颜色标签文本
    colorLabelText: {
      type: String,
      default: "颜色",
    },
    // 是否背景图/颜色
    isBgUrl: {
      type: Boolean,
      default: true,
    },
    // 重置背景颜色
    resetBgColor: {
      type: String,
      default: "",
    },
    // 标签宽度
    labelWidth: {
      type: String,
      default: "90px",
    },
  },
  computed: {
    customerPaperwork: {
      get() {
        return this.customerData;
      },
    },
  },
  methods: {
    imgchecked(file, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
      return new Promise((resolve, reject) => {
        const extension = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();

        if (!ALLOWED_EXTENSIONS.includes(extension)) {
          this.$message.info("所选图片格式不符，请重新选择");
          return reject();
        }

        const image = new Image();
        const _URL = window.URL || window.webkitURL;

        image.onload = () => {
          const valid = image.width === width && image.height === height;
          file.isFlag = valid;

          if (valid) {
            resolve(true);
          } else {
            this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };

        image.src = _URL.createObjectURL(file);
      });
    },

    async beforeUploadUI(file) {
      if (!this.isLimitSize) {
        return true;
      }

      try {
        await this.imgchecked(file, this.pw, this.ph);
        return true;
      } catch {
        return false;
      }
    },

    handleUploadUI(res) {
      if (res.code !== 1) {
        this.$message.error(res.message || "上传失败");
      } else {
        this.customerPaperwork[this.bgKey] = res.data;
        this.$message.success(`${this.labelText}上传成功`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
    .bg-wrap {
      width: 80px;
      &-img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
    .size-tip {
      color: #999;
      margin-left: 12px;
    }
  }
</style>
